import { axios_base } from './axios_base';

const axios_pika = axios_base.create();

axios_pika.interceptors.request.use(
  config => {
    const token = process.env.VUE_APP_PIKA_API_KEY;
    if (token) {
      config.headers["Authorization"] = `Bearer ${token}`;
      config.headers["Content-Type"] = "application/json";
    }
    return config;
  },
  error => {
    return Promise.reject(error);
  }
);

export default axios_pika;
